import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
// import TextField from '@material-ui/core/TextField';
import TextField from '@mui/material/TextField';
import { InputLabel, Paper, Tooltip } from "@mui/material";
import ManageSearchRoundedIcon from '@mui/icons-material/ManageSearchRounded';
import DraggableDialog from "../CustomDialogs/DraggableDialog";
import ProductBrandList from "./Components/ProductBrandList";



const styles = {
    textField: {
        fontFamily: "Customfont !important"
    }
}

export default function ProductBrandInput(props) {
    const { label, id, defaultValue, helperText, inputType, tabIndex, placeholder } = props

    const [inputData, setInputData] = React.useState(defaultValue);
    const [openDialog, setOpenDialog] = React.useState(false);
    const [titleDialog, setTitleDialog] = React.useState("เลือกยี่ห้อ");
    React.useEffect(() => {
        setInputData(defaultValue)
        return () => {
        }
    }, [defaultValue])

    const handleChange = (event) => {
        // event.preventDefault(); 
        console.log("handleChange", event.target.value);
        setInputData(event.target.value);
        try {
            props.resultData(typeof event.target.value === "undefined" ? "" : event.target.value)
        } catch (error) {
        }
    }
    const onBlur = (event) => {
        try {
            props.resultData(typeof event.target.value === "undefined" ? "" : event.target.value)
        } catch (error) {
        }
    }
    const handleKeyDown = (event) => {
        // event.preventDefault(); 
        try {
            //     if (event.key === "Enter") {
            props.keyDown(event.key)
        }
        catch (error) {
            console.log("handleKeyDown err", error);
        }
    }

    const handleSearchClick = () => {
        // console.log("testxxxxx handleSearchClick"); 
        setOpenDialog(true)
    }

    const resultData = async (e) => {
        console.log("resultData", e);
        let code = ""
        for (let index = 0; index < e.length; index++) {
            code += await e[index].code
            code += await index > -1 && index < e.length - 1 ? "," : "";
        }
        //await console.log(Sitecode);
        await setInputData(code)
        await setOpenDialog(false)
        await props.resultData(code)

    }
    return (
        <>
            <Paper
                elevation={0}
                component="div"
                sx={{
                    pl: '5px',
                    pt: '1px',
                    m: "0px",
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: "#eee",
                    border: "1px solid #ccc",
                    verticalAlign: "middle",

                }}

            >
                <Tooltip title={label}>
                    <InputLabel sx={{
                        width: "140px", whiteSpace: "nowrap",
                        fontSize: "16px",
                        fontFamily: "Customfont !important",
                        color: "black",
                        verticalAlign: "middle"
                    }}  >{label}</InputLabel>
                </Tooltip>

                <TextField
                    sx={{
                        //     "& label.Mui-focused": {
                        //         display: "none",
                        //     },
                        //     "& legend": {
                        //         display: "none",
                        //     },
                        backgroundColor: "#fff",
                        fontFamily: "Customfont"
                        //     marginTop: "0px",
                    }}
                    hiddenLabel
                    id={id}
                    // defaultValue={defaultValue}
                    onChange={handleChange}
                    value={inputData}
                    helperText={helperText}
                    variant="standard"
                    size="small"
                    type={inputType}
                    fullWidth
                    tabIndex={tabIndex}
                    placeholder={placeholder}
                    onBlur={e => onBlur(e)}
                    onKeyDown={handleKeyDown}
                    inputProps={{ style: { fontSize: "0.9rem", fontFamily: "Customfont" } }}
                />
                <ManageSearchRoundedIcon sx={{ cursor: "pointer" }} onClick={_ => handleSearchClick()} />
            </Paper>
            <DraggableDialog open={openDialog} title={titleDialog} closeDialog={e => setOpenDialog(e)} >
                <ProductBrandList resultData={e => resultData(e)} />
            </DraggableDialog>
        </>
    );
}
ProductBrandInput.propTypes = {
    label: PropTypes.string,
    id: PropTypes.string,
    defaultValue: PropTypes.string,
    helperText: PropTypes.string,
    inputType: PropTypes.oneOf(["button", "checkbox", "color", "date", "datetime-local", "email", "file", "hidden", "image", "month", "number", "email", "password", "radio", "range", "reset", "search", "submit", "tel", "text", "time-local", "url", "file", "week"]),
    placeholder: PropTypes.string,
    tabIndex: PropTypes.string
}